(function ($, window, _, eventHub, cssCreator) {
	'use strict';
	var pluginName = 'PMSelect';

	var itemTpl = '<div class="upm tbl"><div class="trow" title="<%= title%>">' +
		'<div class="tcell"><div class="upm-label"><%= details %></div></div>' +
		'<div class="tcell upm-sidelogo"><span class="upm-logo <%- pmClass %>"></span></div>' +
		'</div></div>';
	var logo_label_itemTpl = '<div class="upm tbl"><div class="trow" title="<%= title%>">' +
		'<div class="tcell upm-sidelogo"><span class="upm-logo <%- pmClass %>"></span></div>' +
		'<div class="tcell"><div class="upm-label"><%= details %></div></div>' +
		'</div></div>';

	var constants = {
		supportedImageMimeType : {
			"image/gif"     : 1,
			"image/jpeg"    : 1,
			"image/png"     : 1,
			"image/svg+xml" : 1
		},
		resourceTypeUrl : 'url'
	};

	var defaults = {
		pm_label      : 'Other Payment Methods',
		user_pm_label : 'My Payment Methods',
		maxHeight     : 250,
		classPrefix   : 'pm',
		showUserPMs	  : true,
		showMerchantPM: true,
		pm_order_prefix: '', // when the plugin is used as a sub gallery
		customPmNames : {},
		CC_CARDS_DB: {
			'cc_card'   : 1,
			'dc_card'   : 1,
			'paydotcom' : 1,
			'entropay'  : 1
		},
		parser_opt : {
			asteriskTemplate : "**** **** **** ",
			regExCardPattern : /\((\d{4})\)|\d\*{4}(\d{4})|\d\*{3}\s+\*{4}\s+\*{4}\s+(\d{4})/,	// matches (1234) and 3****1234 and 1*** **** **** 3567
		},
		templates :{
			mainTpl: '<select></select>',
			optGroupTpl : '<optgroup class="<%= groupClass%>" label="<%= groupLabel%>"></optgroup>',
			optUpmItemTpl   : itemTpl,
			labelUpmItemTpl : itemTpl,
			optUpmTextTpl   : '<%- item.details%><%if(item.card){%> - <%- item.card%><%}else{if(item.details){%> - <%}%><%- item.label%> <%}%>',
			optUpmTitleTpl  : '<%if(item.card){%> <%- item.card%> <%}else{%> <%- item.label%> <%} if(item.details){%> - <%- item.details%><%}%> ',
		},
		customCssObjCreator : function(imgUrl, className){ return {background: "url('"+ imgUrl+ "') no-repeat center center;"}; },
		customCssRuleSelectorSufix: '', // '' | '::after' | '::before',
		cellOrder	  : 'label-logo' // 'logo-label' | 'label-logo'
	};
	var cardsHash = {
		visa                      : 'Visa',
		discover_card             : 'Discover',
		laser                     : 'Laser Card',
		maestro                   : 'Maestro',
		master_card               : 'MasterCard',
		amex                      : 'Amex',
		jcb                       : 'JCB',
		visa_electron             : 'Visa',
		diners_club_international : 'Diners',
		paydotcom                 : 'Pay.com',
		entropay                  : 'Entropay',
		entropay_visa             : 'Entropay',
		dankort_visa              : 'Visa',
		dankort                   : 'Dankort',
		mir                       : 'Mir',
		astropay_card             : "Astropay Card",
		china_union               : "China Union",
		cc_card                   : 'Credit Card',
		dc_card                   : 'Debit Card'
	};
	/**
	 *
	 * @param name {string}
	 * @returns {string}
	 */
	var getCardType = function (name) {
		if (name && _.isString(name)) {
			return name.split('_my_methods')[0]; // return name.substring(0, name.indexOf('_my_methods'));
		}
		return '';
	};
	function _getUrl(metadata) {
		var url;
		if (metadata && metadata.imgContent && metadata.imgMimeType) {
			if (constants.supportedImageMimeType[metadata.imgMimeType]) {
				var normalizedString = (metadata.imgContent).replace(/(\r\n|\n|\r)/gm, "");
				url = ["data:", metadata.imgMimeType, ";base64,", normalizedString].join('');
			} else if (metadata.imgMimeType === constants.resourceTypeUrl) {
				url = metadata.imgContent.trim();
			}
		}
		return url;
	}
	/**
	 * Default parsers
	 * Could be overwritten
	 * @type {{user_pm: Function, pm: Function}}
	 */
	var Parsers = {
		user_pm : function (userPMArray, parser_opt) {
			var result = {};
			_.each(userPMArray, function (item) {
				var iframe = null;
				var showClass = null;
				var issuer    = item.cardIssuer;
				if (item.attributes && _.has(item.attributes, 'isIframe')) {
					iframe = item.attributes.isIframe;
				}
				var ccCardDetails = parser_opt.regExCardPattern;
				var details = _.escape(item.name);
				if (ccCardDetails.test(details)) {
					details = parser_opt.asteriskTemplate + (details.match(ccCardDetails)[1] || details.match(ccCardDetails)[2] || details.match(ccCardDetails)[3]);
					showClass = item.type || item.card_type || getCardType(item.className) || item.paymentOptionName;
					issuer = issuer || showClass;
					// Hack for WD
					if(item.paymentOptionName == "visa_checkout"){
						showClass = item.paymentOptionName;
					}
				} else {
					showClass = item.paymentOptionName || item.type || item.card_type || getCardType(item.className);
					issuer = issuer || item.displayPaymentOptionName;
				}
				showClass = _.escape(showClass.toLowerCase());
				var key = item.userPaymentOptionId || -1;
				result[key] = {
					uniqueId  : parseInt(item.userPaymentOptionId) || -1,
					label     : item.displayPaymentOptionName || '',
					name      : item.paymentOptionName || '',
					isIframe  : iframe,
					showClass : showClass,
					details   : details || '',
					issuer    : issuer,
					rawData   : item || {}
				};
			});
			return result;
		},
		pm      : function (merchantPMArray) {
			return _.map(merchantPMArray, function (item) {
				var iframe = null;
				if (item.attributes && _.has(item.attributes, 'isIframe')) {
					iframe = item.attributes.isIframe;
				}
				var showClass = item.value || '';
				showClass = showClass.toLowerCase();
				return {
					uniqueId : item.value,
					label    : item.label,
					name     : showClass,
					isIframe : iframe,
					rawData  : item
				};
			});
		}
	};

	/**
	 * Plugin constructor
	 * @param element
	 * @param options
	 * @constructor
	 */

	function Plugin(element, options) {
		this.element = element;
		this.lastSelectedVal = null;
		this._lastEventTimestamp = 0;
		if(options && options.cellOrder === 'logo-label'){ // 'logo-label' => SafecapDesktopPurchase.ftl, SafecapMobilePurchase.ftl
			this.options = $.extend(true, {}, defaults, {templates:{optUpmItemTpl:logo_label_itemTpl, labelUpmItemTpl:logo_label_itemTpl}}, options);
		} else {
			this.options = $.extend(true, {}, defaults, options);
		}
		this.template = _.template(this.options.templates.mainTpl);
		this.select = $(this.template(this.options));
		this.optGroupTpl = _.template(this.options.templates.optGroupTpl);
		this.init();

	}

	/**
	 * Class initialization
	 */
	Plugin.prototype.init = function () {
		cssCreator.setup(this.options.cssCreator);
		$(this.element).append(this.select);
		if(this.options.showMerchantPM) {
			pubsub.subscribe('pm-available', function (data) {
				this.updateData('pm', data);
			}, this);
		}
		if(this.options.showUserPMs) {
			pubsub.subscribe('user-pm-available', function (data) {
				this.updateData('user_pm', data);
				this.lastSelectedVal = null;
			}, this);
		}
		pubsub.subscribe('dr-select-pm', function (data) {
			var uniqueId = (data.type && data.type === 'int') ? parseInt(data.uniqueId, 10) : data.uniqueId;
			this.handleDR(uniqueId, data.type);
		}, this);

		$(this.element).on('change', 'select', _.bind(function () {
			var currentTime = (new Date()).getTime();
			// filter ghost events
			if (currentTime - this._lastEventTimestamp < 10) {
				this._lastEventTimestamp = currentTime;
				return true;
			}
			var selectedVal = $(this.element).find('option:selected').val();
			if(this.lastSelectedVal != selectedVal) {
				var retData = {};
				if (isNaN(parseInt(selectedVal))) {
					retData = this.options['pm_data'][_.findIndex(this.options['pm_data'], {uniqueId : selectedVal})];
				}
				else {
					retData = this.options['user_pm_data'][selectedVal];
				}
				if (retData) {
					retData.pmPosition = this.order[selectedVal];
					eventHub.publish('select-pm', [retData]);
				}
				this.lastSelectedVal = selectedVal;
			} else if(this.lastSelectedVal ) {
				eventHub.publish('select-pm-attempt', [{uniqueId : selectedVal}]);
			}
			this._lastEventTimestamp = currentTime;
		}, this));
	};

	Plugin.prototype.updatePmPosition = function () {
		var self = this;
		var order = {};
		var upmItems = self.select.find('.user_pm option');
		var pmItems = self.select.find('.pm option');
		var items = [].concat(upmItems.toArray(), pmItems.toArray());
		_findOrder(items, self.options.pm_order_prefix);
		self.order = order;

		function _findOrder(arr, prefix) {
			prefix = prefix ? prefix + "." : '';
			var count = 0;
			var upoCount = 0;
			_.each(arr, function (item, idx) {
				var id = item.value;
				var isUpo = isNaN(parseInt(id));
				var pos = prefix + (++count);
				var subPos = '' + (isUpo ? ++upoCount : count - upoCount);
				order[id] = {absolute: pos, relative: subPos};
			});
		}
	};

	/**
	 *
	 * @param data_type
	 * @param data
	 */
	Plugin.prototype.updateData = function (data_type, data) {
		var self = this;
		this.options[data_type + '_data'] = Parsers[data_type](data || [], self.options.parser_opt);
		var optGroup = this.select.find('.' + data_type);
		if (!optGroup.length) {
			optGroup = $(this.optGroupTpl({
				groupClass : data_type,
				groupLabel : this.options[data_type + '_label'] || 'data_type'
			}));

			if (data_type === 'user_pm') {
				var pmOptGroup = this.select.find('.pm');
				var pmOptGroupExists = pmOptGroup.length;
				if (pmOptGroupExists) {
					pmOptGroup.before(optGroup);
				} else {
					this.select.append(optGroup);
				}
			} else {
				this.select.append(optGroup);
			}
		}
		optGroup.find('option').remove();
		_.each(data, function (item) {
			var jqOption = $('<option></option>');
			if (data_type === 'user_pm') {
				var meta = self.options['user_pm_data'][item.userPaymentOptionId];
				jqOption.val(item.userPaymentOptionId);
				var pmClass;
				var url = _getUrl(meta.rawData.metadata);
				var payload = {
					details : meta.details,
					label   : meta.label,
					name    : meta.name,
					rawData : meta.rawData
				};
				if ( self.options.CC_CARDS_DB[meta.name] ) {
					pmClass = meta.rawData.card_type || meta.rawData.type || getCardType(meta.rawData.className);
					payload.card = cardsHash[pmClass];
				} else {
					pmClass = meta.name.toLowerCase().replace(/[^A-Za-z0-9]+/g, "_");
				}
				var showClass = pmClass.toLowerCase() + (url ? '_' + meta.uniqueId + '_modified' : '');
				if (url) {
					meta.imgUrl = url;
					var cssObj = self.options.customCssObjCreator(url, showClass);
					cssCreator.addCustomRule(showClass + self.options.customCssRuleSelectorSufix, cssObj);
				} else {
					cssCreator.makeRule(showClass);
				}
				var textLabel = _.template(self.options.templates.optUpmTextTpl)({item: payload});
				jqOption.text(textLabel);
			} else {
				if (!item.value) {
					//console.log('Fuck', item);
					//TODO : decide what to do if incorrect data
				} else {
					var className = item.value.toLowerCase().replace(/[^A-Za-z0-9]+/g, "_");
					cssCreator.makeRule(className);
					jqOption.val(item.value);
					var pmLabel = self.options.customPmNames[item.value] ? self.options.customPmNames[item.value] : item.label;
                    jqOption.text(pmLabel);
				}
			}
			optGroup.append(jqOption);
		});
		if (_.isEmpty(data)) {
			optGroup.remove();
		}
		self.updatePmPosition();
		if (!this.selectricRes && this.select.find('option').length) {
			this.selectricRes = this.select.selectric({
				maxHeight          : this.options.maxHeight,
				responsive         : true,
				labelBuilder       : function (itemData) {
					if (!itemData || !itemData.element) {
						return 'No Data';
					}
					var value = itemData.element.val();
					if (isNaN(parseInt(value))) {
						if (value === 'cc_card' || value === 'dc_card') {
							return '<span class="pm-label ' + itemData.element.val() + '" title="' + itemData.text + '"><div class="cc-card-medium cc_card"><div class="x-middle visa-ico cc-first"></div><div class="x-middle master_card"></div><div class="x-middle cc-third"></div><div class="x-middle cc-fourth"></div></div></span>';
						}

						var labelClass = itemData.element.val() || '';
						labelClass = labelClass.toLowerCase().replace(/[^A-Za-z0-9]+/g, "_");
						var classExists = cssCreator.makeRule(labelClass);
						if (classExists) {
							return '<span class="pm-label ' + labelClass + '" title="' + itemData.text + '"></span>';
						}
						return '<span class="pm-label ' + labelClass + '" title="' + itemData.text + '">' + itemData.text + '</span>';
					} else {
						var meta = self.options['user_pm_data'][value];
						var titlePayload = {
							label   : meta.label,
							details : meta.details
						};
						var pmClass = meta.name.toLowerCase();
						if ( self.options.CC_CARDS_DB[meta.name] ) {  // if (meta.name === 'cc_card' || meta.name === 'dc_card') {
							pmClass = meta.rawData.card_type || meta.rawData.type || getCardType(meta.rawData.className);
							titlePayload.card = cardsHash[pmClass];
						}
						var showClass = pmClass.toLowerCase() + (meta.imgUrl ? '_' + meta.uniqueId + '_modified' : '');
						// NEW >>
						var itemTitle = itemData.text; //TODO: _.template(self.options.templates.optUpmTitleTpl)({item: titlePayload});
						var payload = {
							title   : itemTitle,
							pmClass : showClass,
							details : meta.details,
							label   : (titlePayload.card || meta.label),
							imgUrl  : meta.imgUrl,
							meta    : meta
						};
						var html = _.template( self.options.templates.labelUpmItemTpl )(payload);
						return html;
						// << NEW
					}
				},
				optionsItemBuilder : function (itemData, element) {
					var value = element.val();
					var className = value || '';
					className = className.toLowerCase().replace(/[^A-Za-z0-9]+/g, "_");

					if (isNaN(parseInt(value))) {
						var classExists = cssCreator.makeRule(className);
						if (value === 'cc_card' || value === 'dc_card') {
							return '<span class="ico ' + className + '" title="' + itemData.text + '"><div class="cc-card-medium cc_card"><div class="x-middle visa-ico cc-first"></div><div class="x-middle master_card"></div><div class="x-middle cc-third"></div><div class="x-middle cc-fourth"></div></div></span>';
						}
						if (classExists) {
							return '<span class="ico ' + className + '" title="' + itemData.text + '"></span>';
						} else {
							return '<span class="ico ' + className + '" title="' + itemData.text + '">' + itemData.text + '</span>';
						}

					} else {
						var meta = self.options['user_pm_data'][value];
						var titlePayload = {
							label   : meta.label,
							details : meta.details
						};
						var pmClass = meta.name.toLowerCase().replace(/[^A-Za-z0-9]+/g, "_");
						if ( self.options.CC_CARDS_DB[meta.name] ) {  // if (meta.name === 'cc_card' || meta.name === 'dc_card') {
							var cardType = meta.rawData.card_type || meta.rawData.type || getCardType(meta.rawData.className);
							pmClass = cardType;
							titlePayload.card = cardsHash[pmClass];
						}
						var showClass = pmClass + (meta.imgUrl ? '_' + meta.uniqueId + '_modified' : '');

						// NEW >>
						var itemTitle = _.template(self.options.templates.optUpmTitleTpl)({item: titlePayload});
						var payload = {
							title   : itemTitle,
							pmClass : showClass, // pmClass,
							details : meta.details,
							label   : (titlePayload.card || meta.label),
							imgUrl  : meta.imgUrl,
							meta    : meta
						};
						var html = _.template( self.options.templates.optUpmItemTpl )(payload);
						return html;
						// << NEW
					}
				}
			});
		}
		this.select.selectric('refresh');
	};

	Plugin.prototype.handleDR = function (uniqueId, idType) {
		var that = this;
		var id = uniqueId;
		function _selectById (id) {
			var isDesktopMode = $('[data-pms-type="dropdown"] .selectric-items').length;
			if (isDesktopMode) {     // selectric in DESKTOP mode
				var pm_type = isNaN(parseInt(id)) ? 'pm' : 'user_pm';
				var optIdx = $('[data-pms-type="dropdown"] select optgroup option[value="' + id + '"]').index();
				var $li = $('ul.' + pm_type + ' li[data-index]');
				if ($li.length && optIdx >= 0 && $li.length >= optIdx) {
					var $exactLi = $($li[optIdx]);
					if ($exactLi.hasClass("selected")) {
						that.select.val(id).change();
					} else {
						$exactLi.trigger('click');
					}
					return true;
				}
			} else if( $('option[value="' + id + '"]', that.select).length ) {   // selectric in MOBILE mode
				that.select.val(id).change();
				return true;
			}
			return false;
		}
		if (uniqueId === "auto_select" && idType === "auto_select"){
			 id = $('[data-pms-type="dropdown"] select optgroup option').val();
		} else if (uniqueId === "auto_select" && idType === "pm"){
			 id = $('[data-pms-type="dropdown"] select optgroup.pm option').val();
		}
		if (id) {
			_selectById(id);
		}
	};

	/**
	 *
	 * @param uniqueId
	 * @returns {boolean}
	 */
	Plugin.prototype.hasItemId = function (uniqueId) {
		return _.findIndex(this.options.data, function (item) {
				return item.uniqueId === uniqueId;
			}) > -1;
	};

	/**
	 * Plugin initialization
	 * @param options
	 * @returns {*}
	 */
	$.fn[pluginName] = function (options) {
		return this.each(function () {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));
			}
		});
	};
})(jQuery, window, _, pubsub, cssCreator);